export const PAGE_IS_LOADED = 'PAGE_IS_LOADED'
export const pageIsLoaded = (isLoaded) => ({
    type:PAGE_IS_LOADED,
    payload:isLoaded
})



// WEBPACK FOOTER //
// ./src/actions/pageLoad.js